import { PlacementsList } from './placements-list';

export { PlacementsList };
